import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/locationgcc/sa/saudiback.webp";
import { StaticImage } from "gatsby-plugin-image";

function Banner({ rtl }) {
  const className = rtl ? "locationgcc_banner rtl-style" : "locationgcc_banner";
  return (
    <div className={className} style={{ backgroundImage: `url(${BgImg})` }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1>
                شركة تصميم تطبيقات الجوال في المملكة
                <span>العربية السعودية </span>
              </h1>
              <p className="main_para">
                تفتخر TekRevol بتقديم خدمات تطوير تطبيقات الهاتف المحمول في
                المملكة العربية السعودية، بما في ذلك متطلبات التطبيق تتشابه
                متطلبات تطبيقات اندرويد وآي أو إس مع بعضها البعض. تستخدم
                تطبيقاتنا المطورة في المملكة العربية السعودية التقنيات الحديثة
                لبناء حلول شاملة للهاتف المحمول. هدفنا هو مساعدة الشركات على
                التحول من خلال تطوير تطبيقات الهاتف المحمول المبتكرة والقوية
                والرائدة، والتي سترفع الاستثمار إلى المستوى التالي.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                هيا بنا نبدأ
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <StaticImage
              src="../../../images/locationgcc/sa/saudibanner.webp"
              alt="mobile app development company in dubai"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
